module.exports = __webpack_public_path__ + "img/53.57417fd.jpg";